export default __webpack_public_path__ + "static/media/blue_lagoon_2_lowdef.4aecaa3a.png";